"use strict";
exports.__esModule = true;
exports.StopMappedBy = exports.LocationType = exports.TicketType = exports.LayoutType = exports.TrainAndFerryFeature = exports.Feature = exports.SafetyFeature = exports.ComplimentaryAmenity = exports.FoodOption = exports.SeatFeature = exports.SeatType = exports.PassengerState = void 0;
var PassengerState;
(function (PassengerState) {
    /** Minimal information collected about the passenger at the time of search. */
    PassengerState["Search"] = "search";
    /** Intermediate information (name / question responses) may be available at this time. */
    PassengerState["Checkout"] = "checkout";
    /** Full information about the passenger is available and final. */
    PassengerState["Booking"] = "booking";
})(PassengerState = exports.PassengerState || (exports.PassengerState = {}));
var SeatType;
(function (SeatType) {
    SeatType["SmallSeat"] = "small_seat";
    SeatType["AverageSeat"] = "average_seat";
    SeatType["XLSeat"] = "xl_seat";
})(SeatType = exports.SeatType || (exports.SeatType = {}));
var SeatFeature;
(function (SeatFeature) {
    /** The seat fully reclines (161-180 degrees flat) */
    SeatFeature["FullReclineSeat"] = "full_recline_seat";
    /** The seat somewhat reclines (121-160 degrees) */
    SeatFeature["SemiReclineSeat"] = "semi_recline_seat";
    /** The seat barely reclines (91-120 degrees) */
    SeatFeature["AverageReclineSeat"] = "average_recline_seat";
    /** The seat is basically a bed */
    SeatFeature["SleeperSeat"] = "sleeper_seat";
    /** The seat has insane views */
    SeatFeature["PanoramicSeat"] = "panoramic_seat";
    /** The seat has spacious legroom */
    SeatFeature["ExtraLegroom"] = "extra_legroom";
    /** The seat has extra support for the legs */
    SeatFeature["LegSupportAvailable"] = "leg_support_available";
    /** A child seat is required if a child is sitting in this seat */
    SeatFeature["ChildSeatRequired"] = "child_seat_required";
})(SeatFeature = exports.SeatFeature || (exports.SeatFeature = {}));
var FoodOption;
(function (FoodOption) {
    FoodOption["Water"] = "water";
    FoodOption["BarService"] = "bar_service";
    FoodOption["Snack"] = "snack";
    FoodOption["Refreshment"] = "refreshment";
    FoodOption["Food"] = "food";
    FoodOption["HotMeal"] = "hot_meal";
    FoodOption["PaidWater"] = "paid_water";
    FoodOption["PaidBarService"] = "paid_bar_service";
    FoodOption["PaidSnack"] = "paid_snack";
    FoodOption["PaidHotMeal"] = "paid_hot_meal";
})(FoodOption = exports.FoodOption || (exports.FoodOption = {}));
var ComplimentaryAmenity;
(function (ComplimentaryAmenity) {
    /** A pillow is given onboard */
    ComplimentaryAmenity["Pillow"] = "pillow";
    /** A blanket is given onboard */
    ComplimentaryAmenity["Blanket"] = "blanket";
    /** Slippers are given onboard */
    ComplimentaryAmenity["Slippers"] = "slippers";
})(ComplimentaryAmenity = exports.ComplimentaryAmenity || (exports.ComplimentaryAmenity = {}));
var SafetyFeature;
(function (SafetyFeature) {
    /** Passengers can see where their vehicle is in live time */
    SafetyFeature["OperatorLiveGpsTracking"] = "operator_live_gps_tracking";
    /** Cameras are installed on the vehicle */
    SafetyFeature["CamerasOnboard"] = "cameras_onboard";
    /** There is an AED (automated external defibrillator) in the vehicle */
    SafetyFeature["AED"] = "aed";
    /** There is a first aid kit onboard */
    SafetyFeature["FirstAidKit"] = "first_aid_kit";
    /** The vehicle has handrails to hold onto */
    SafetyFeature["Handrails"] = "handrails";
    /** There are seat belts for every seat */
    SafetyFeature["SeatBelts"] = "seat_belts";
    /**
     * The vehicle is for women and children only, for safety reasons. Not enforced by the backend.
     * If you'd like to enforce gender seat selection, please use VehicleRules.gendered_seat and SeatCell.gender
     */
    SafetyFeature["WomenAndChildrenPreferred"] = "women_and_children_preferred";
})(SafetyFeature = exports.SafetyFeature || (exports.SafetyFeature = {}));
var Feature;
(function (Feature) {
    Feature["Wifi"] = "wifi";
    /** Wifi can be purchased onboard */
    Feature["PaidWifi"] = "paid_wifi";
    Feature["IndividualTv"] = "individual_tv";
    Feature["IndividualSatelliteTv"] = "individual_satellite_tv";
    /** There is one or more shared tvs */
    Feature["Tv"] = "tv";
    /** There are movies for viewing */
    Feature["Movies"] = "movies";
    Feature["PowerOutlets"] = "power_outlets";
    /** There are more passengers than power outlets available (or power outlet is not guaranteed) */
    Feature["SharedPowerOutlets"] = "shared_power_outlets";
    Feature["BusAttendant"] = "bus_attendant";
    /** Service is available for those who need assistance */
    Feature["AssistantService"] = "assistant_service";
    /** There is service onboard */
    Feature["OnboardService"] = "onboard_service";
    Feature["AC"] = "ac";
    /** The vehicle is heated, or it can be */
    Feature["Heating"] = "heating";
    Feature["Toilet"] = "toilet";
    /** There's an exclusive toilet to the floor of the bus */
    Feature["FloorExclusiveToilet"] = "floor_exclusive_toilet";
    /** Access to a lounge at the origin or destination station */
    Feature["LoungeAccess"] = "lounge_access";
    /** Checked baggage service offered by operator staff */
    Feature["CheckedBaggage"] = "checked_baggage";
    /** Indicates assigned seating is enforced on the vehicle, despite manual seat selection not being available */
    Feature["ReservedSeats"] = "reserved_seats";
    /** Indicates the vehicle is fully wheelchair-accessible */
    Feature["WheelchairRamp"] = "wheelchair_ramp";
    /** Indicates the vehicle allows for in-seat dining (usually in addition to the presence of a cafe/dining car) */
    Feature["TrayMeal"] = "tray_meal";
    /** The bus will be sanitized prior to boarding */
    Feature["Sanitized"] = "sanitized";
    /** The vehicle comes with a compartment for bike storage */
    Feature["BikeStorage"] = "bike_storage";
    /** Pets are welcome onboard */
    Feature["PetsAllowed"] = "pets_allowed";
})(Feature = exports.Feature || (exports.Feature = {}));
var TrainAndFerryFeature;
(function (TrainAndFerryFeature) {
    /** Access to a lounge on the train/ferry */
    TrainAndFerryFeature["LoungeAccessOnboard"] = "lounge_access_onboard";
    /** Access to a meeting room on the train/ferry */
    TrainAndFerryFeature["MeetingRoom"] = "meeting_room";
    /** Access to a quiet zone or compartment on the train/ferry */
    TrainAndFerryFeature["QuietZone"] = "quiet_zone";
    /** Access to a dining room onboard the train/ferry */
    TrainAndFerryFeature["Restaurant"] = "restaurant";
    /** Access to a café onboard the train/ferry */
    TrainAndFerryFeature["Cafe"] = "cafe";
})(TrainAndFerryFeature = exports.TrainAndFerryFeature || (exports.TrainAndFerryFeature = {}));
var LayoutType;
(function (LayoutType) {
    LayoutType["TwoPlusTwo"] = "2+2";
    LayoutType["TwoPlusOne"] = "2+1";
})(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
var TicketType;
(function (TicketType) {
    TicketType["Print"] = "print";
    TicketType["ETicket"] = "eticket";
    TicketType["Claim"] = "claim";
    TicketType["Voucher"] = "voucher";
    TicketType["IDOnly"] = "id-only";
    TicketType["SupplierEmail"] = "supplier-email";
})(TicketType = exports.TicketType || (exports.TicketType = {}));
var LocationType;
(function (LocationType) {
    LocationType["Airport"] = "airport";
    LocationType["BusStation"] = "bus_station";
    LocationType["BusStop"] = "bus_stop";
    LocationType["SubwayStation"] = "subway_station";
    LocationType["TrainStation"] = "train_station";
    LocationType["TransitStation"] = "transit_station";
    LocationType["Port"] = "port";
    LocationType["CityCenter"] = "city_center";
    LocationType["Other"] = "other";
})(LocationType = exports.LocationType || (exports.LocationType = {}));
var StopMappedBy;
(function (StopMappedBy) {
    StopMappedBy["CityCenterMapper"] = "city_center_mapper";
    StopMappedBy["DedupeLocations"] = "dedupe_locations";
    StopMappedBy["LowDetailsMapper"] = "low_details_mapper";
    StopMappedBy["Manual"] = "manual";
    StopMappedBy["RadiusMapper"] = "radius_mapper";
    StopMappedBy["LocationsCreatorMapper"] = "locations_creator_mapper";
    StopMappedBy["LocationsAndCitiesCreatorMapper"] = "locations_and_cities_creator_mapper";
})(StopMappedBy = exports.StopMappedBy || (exports.StopMappedBy = {}));
